// [UTILITAIRE SIMPLE] Gestionnaire réponse login pour première connexion
// [RÔLE] Stocker le flag is_first_login depuis la réponse API dans sessionStorage
// [ARCHITECTURE] Fonction simple à appeler après le login

/**
 * Traiter la réponse de login et stocker le flag is_first_login
 * À appeler dans votre composant de login après une réponse API réussie
 */
export const handleLoginSuccess = (loginResponse: any) => {
  try {
    const isFirstLogin = loginResponse?.data?.is_first_login;
    const pendingAnnouncements: string[] = loginResponse?.data?.pending_announcements ?? [];

    // List of announcements this user should still see — set by the server-side script.
    // Empty for new users (they never see old announcements).
    sessionStorage.setItem('pending_announcements', JSON.stringify(pendingAnnouncements));

    if (isFirstLogin === true) {
      sessionStorage.setItem('api_first_login', 'true');
      return true;
    } else {
      sessionStorage.removeItem('api_first_login');
      return false;
    }
  } catch (error) {
    console.warn('Erreur traitement réponse login:', error);
    return false;
  }
};

export default handleLoginSuccess;
